export { default } from "./validateComponent";
